<div class="container">
  <img class="logo" loading="lazy" [src]="RESPONSABLE_TOURISM | baseImage : RESPONSABLE_TOURISM_PATH">
</div>
